import { Injectable, inject } from '@angular/core';
import { CoreService, UtilsService } from 'src/app/common';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrganizationInvitesService {
    private core = inject(CoreService<{}>);
    private utils = inject(UtilsService);
    private identityBaseUrl = environment.identityUrl; // Adjust as needed

    /**
     * Accept an organization invite with a token.
     * @param token The invitation token
     */
    async acceptOrgInvite(token: string): Promise<any> {
        this.utils.logger.info('acceptOrgInvite() Posting invite token', token);
        try {
            const url = `${this.identityBaseUrl}/OrgInvites/accept`;
            const data = await firstValueFrom(this.core.post(url, { token }));
            this.utils.logger.info('acceptOrgInvite() success:', data);
            return data;
        } catch (error) {
            this.utils.logger.error('acceptOrgInvite() error:', error);
            throw error;
        }
    }

    async getOrganizationByInviteToken(inviteToken: string): Promise<any> {
        this.utils.logger.info('getOrganizationByInviteToken() Posting invite token', inviteToken);
        try {
            const url = `${this.identityBaseUrl}/OrgInvites/organization`;
            const data = await firstValueFrom(this.core.post(url, { token: inviteToken }));
            this.utils.logger.info('getOrganizationByInviteToken() success:', data);
            return data;
        } catch (error) {
            this.utils.logger.error('getOrganizationByInviteToken() error:', error);
            throw error;
        }
    }
}
